import styled from 'styled-components';
import { PropertyCardBadgeAreaMixin } from '../../mixins/components/PropertyCardBadgeAreaMixin';
export var StyledPropertyCardBadgeArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardBadgeArea",
  componentId: "c11n-8-111-1__sc-11omngf-0"
})(["", ""], PropertyCardBadgeAreaMixin);